// extracted by mini-css-extract-plugin
module.exports = {"balance":"Balance_balance__25StT","balanceDeposit":"Balance_balanceDeposit__3QjjJ","balanceWithdrawal":"Balance_balanceWithdrawal__BZrEd"};